<template>
  <el-container>
    <el-main ref="print" class="p-0 ContractMultiPrint" :class="{ landscape: isLandscape }">
      <div>
        <table class="table-border--2 w-full">
          <tr>
            <td cell-padding="0">
              <div class="title">{{title}}</div>
              <div class="flex">
                <div class="flex-auto info align-center">
                  <span>{{service_date}}</span>
                  <hr />
                  <div v-if="addr_editing" class="addr">{{temp_customer_name + " " + "귀중"}}</div>
                  <div v-else>
                    <el-input type="textarea" v-model="temp_customer_name" />
                  </div>
                  <button class="no-print mt-default" @click="toggleAddrEditing">{{btn_addr_text}}</button>
                  <div class="bold font-middle mt-default">￦ {{data.price | number}}</div>
                </div>
                <div class="flex-fixed" style="width: 50%">
                  <div class="stamp right">
                    <img :src="siteStampPath" height="60" />
                  </div>
                  <table class="supplier-table table-border__solid table-border--2 align-center">
                    <col width="5%" />
                    <col width="20%" />
                    <col width="30%" />
                    <col width="15%" />
                    <col width="30%" />
                    <tr>
                      <td rowspan="6">공 급 자</td>
                      <td>등록번호</td>
                      <td colspan="3">{{company.crn}}</td>
                    </tr>
                    <tr>
                      <td>상 호</td>
                      <td>{{company.name}}</td>
                      <td>성 명</td>
                      <td>{{company.owner}}</td>
                    </tr>
                    <tr>
                      <td>
                        사업장
                        <br />소재지
                      </td>
                      <td colspan="3">{{company.addr}}</td>
                    </tr>
                    <tr>
                      <td>업 태</td>
                      <td>{{company.conditions}}</td>
                      <td>종 목</td>
                      <td><span style="min-height: 41px; word-break: break-word; white-space: normal; display: flex; align-items: center; justify-content: center;">{{company.item}}</span></td>
                    </tr>
                    <tr>
                      <td>대표전화</td>
                      <td>{{company.tel}}</td>
                      <td>팩스</td>
                      <td>{{company.fax}}</td>
                    </tr>
                    <tr class="email">
                      <td>이메일</td>
                      <td colspan="3">
                        <div class="inline">
                          <div v-if="email_editing">
                            <el-input v-model="company.email" />
                          </div>
                          <div v-else>{{company.email}}</div>
                        </div>
                        <button
                          class="no-print inline ml-default"
                          @click="toggleEmailEditing"
                        >{{btn_email_text}}</button>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <table class="detail-table table-border__solid w-full align-center">
              <col :width="isLandscape ? 45 : 50" />
              <col :width="isLandscape ? 150 : '30%'" />
              <col :width="isLandscape ? 70 : 45" />
              <col :width="isLandscape ? 60 : 40" />
              <col :width="isLandscape ? 30 : 40" />
              <col :width="isLandscape ? 30 : 40" />
              <col v-if="isTotalPyung" :width="isLandscape ? 60 : 60" />
              <col :width="isLandscape ? 65 : 80" />
              <col v-if="showPyungProcessingCost" :width="isLandscape ? 65 : 80" />
              <col v-if="showPyungProcessingCost" :width="isLandscape ? 65 : 80" />
              <col :width="isLandscape ? 65 : 80" />
              <col :width="isLandscape ? 65 : 60" />
              <col v-if="showPyungProcessingCost" :width="isLandscape ? 70 : 90" />
              <col />
                <tr>
                  <td>
                    합계
                    <br />금액
                  </td>
                  <td :colspan="colspanOption" class="price">
                    <span>일금 {{data.price | numberToKorean}}</span>
                    <span class="font-small">(VAT포함)</span>
                  </td>
                </tr>
                <tr>
                  <th>날짜</th>
                  <th>품목</th>
                  <th>규격</th>
                  <th>평</th>
                  <th>수량</th>
                  <th>단위</th>
                  <th v-if="isTotalPyung">총평수</th>
                  <th>단가</th>
                  <th v-if="showPyungProcessingCost">평단가</th>
                  <th v-if="showPyungProcessingCost">가공비</th>
                  <th>공급가액</th>
                  <th>세액</th>
                  <th v-if="showPyungProcessingCost">금액</th>
                  <th>비고사항</th>
                </tr>
                <tr v-for="d in details" v-bind:key="d.id" :class="[{'landscape-font': isLandscape}]">
                  <td>{{resolveDate(d) }}</td>
                  <td class="align-left">{{d.product_name}}</td>
                  <td>{{d.size}}</td>
                  <td>{{isGlass(d, d.size)}}</td>
                  <td>{{d.amount}}</td>
                  <td>{{d.unit_name}}</td>
                  <td v-if="isTotalPyung">{{ isGlass(d, d.size) ? (d.amount * isGlass(d, d.size)).toFixed(2) : '' }}</td>
                  <td class="cell-number">{{d.cost | number}}</td>
                  <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(d.pyung_cost)}}</td>
                  <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(d.item_processing_cost)}}</td>
                  <td class="cell-number">{{d.supply_price | number}}</td>
                  <td class="cell-number">{{d.tax | number}}</td>
                  <td v-if="showPyungProcessingCost" class="cell-number mark">{{util.addComma(d.price)}}</td>
                  <td class="align-left">
                    <AFitText>{{(d.desc || '') + (isShowField ? `${d.field ? ` (${d.field})` : ''}` : '')}}</AFitText>
                  </td>
                </tr>
                <tr v-if="isTotal" :class="[{'landscape-font': isLandscape}]">
                  <th colspan="4">합계</th>
                  <td class="cell-number">{{data.amount | number}}</td>
                  <td class="cell-number"></td>
                  <td v-if="isTotalPyung" class="cell-number">{{total_pyung}}</td>
                  <td class="cell-number"></td>
                  <td v-if="showPyungProcessingCost" class="cell-number"></td>
                  <td v-if="showPyungProcessingCost" class="cell-number">{{total_item_processing_cost | number}}</td>
                  <td class="cell-number">{{data.supply_price | number}}</td>
                  <td class="cell-number">{{data.tax | number}}</td>
                  <td v-if="showPyungProcessingCost" class="cell-number">{{data.price | number}}</td>
                  <td>&nbsp;</td>
                </tr>
                <tr v-else>
                  <th colspan="6">합계금액</th>
                  <td class="cell-number" colspan="3">{{data.price | number}}</td>
                  <td>&nbsp;</td>
                </tr>
                <tr class="desc-row">
                  <td>비고</td>
                  <td :colspan="colspanOption" class="align-left pl-default">
                    <div class="inline">
                      <div v-if="bankAccount_editing">
                        <el-input v-model="temp_bankAccountId" />
                      </div>
                      <div v-else>{{temp_bankAccountId}} 예금주 {{company.name}}</div>
                    </div>
                    <button
                      class="no-print ml-default"
                      @click="toggleBankAccountEditing"
                    >{{btn_bankAccount_text}}</button>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <div class="right">
          <img :src="siteLogoPath" height="42" />
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="clickPrint"
        @click="clickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="closeDialog" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { site } from "@/common/mixins/site";
import { company_info } from "@/common/mixins/company_info";
import Print from "@/plugins/print/print";
import AFitText from "@/shared/AFitText";

Vue.use(Print);

export default {
  name: "ContractMultiPrint",
  mixins: [site, company_info],
  components: { AFitText },
  data() {
    return {
      company: {
        income_trade_print_type: 'portrait',
        show_pyung_processing_cost: false,
        income_trade_print_field: false,
        income_trade_print_pyung: false,
        invoice_type: 'trading',
        is_total: false,
      },
      temp_destination: "",
      btn_addr_text: "변경",
      btn_email_text: "변경",
      btn_bankAccount_text: "변경",
      email: "hwa7132@naver.com",
      addr_editing: true,
      email_editing: false,
      bankAccount_editing: false,
      temp_customer_name: "",
      temp_bankAccountId: "",
      service_date: this.util.getDate(),
      total_pyung: 0,
      total_item_processing_cost: 0,
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    customer: {
      type: Object,
      required: true
    },
    estimation_date_flag: {
      type: Boolean
    }
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    ...mapGetters(["table_config", "table_account"]),
    isLandscape() {
      return this.company.income_trade_print_type === "landscape";
    },
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    isShowField() {
      return this.company.income_trade_print_field;
    },
    isTotalPyung() {
      return this.company.income_trade_print_pyung;
    },
    isTotal() {
      return this.company.is_total;
    },
    printType() {
      return this.company.invoice_type
    },
    colspanOption() {
      let defaultColSpan = 8
      if(this.isTotalPyung){
        defaultColSpan += 1
      }
      if (this.showPyungProcessingCost) {
        defaultColSpan += 4
      }
      return defaultColSpan
    },
    details() {
      let items = Object.assign([], this.data.details);
      if (items.length < 6) {
        for (let i = items.length; i < 6; i++) {
          items.push({});
        }
      }
      return items;
    },
    bankAccountId() {
      let account_id = this.customer.account_id;
      if (!account_id) {
        let item = this.table_config.find(c => c.key === "account");
        account_id = item.value.represent;
      }
      let account = this.table_account.find(o => o.id === account_id);
      return account ? account.bank_name + " " + account.number : "";
    },
    contract_date() {
      return this.data.contract_date
        ? this.data.contract_date
        : this.data.estimate_date;
    }
  },
  created() {
    this.email = this.company.email;
  },
  mounted() {
    this.loadConfig();
    let total_pyung = 0
    let total_item_processing_cost = 0
    this.data.details.forEach(d => {
      const item_pyung = this.isGlass(d, d.size) || 0
      total_pyung += item_pyung * d.amount
      total_item_processing_cost += d.item_processing_cost || 0
    });
    this.total_pyung = Math.round(total_pyung * 100) / 100
    this.total_item_processing_cost = this.util.addComma(total_item_processing_cost)
    if (this.data.customer_id === 8036) {
      //현대AS 건은 고객명대신 주소를 업체명에 표시한다.
      this.temp_customer_name = this.data.destination
        ? this.data.destination
        : this.data.addr;
    } else {
      this.temp_customer_name = this.data.customer_name;
    }
    this.temp_bankAccountId = this.bankAccountId;
  },
  methods: {
    resolveDate(data) {
      let date = "";
      let ar_date = [];
      if (data.id) {
        if (this.estimation_date_flag) {
          date = this.data.estimate_date;
        } else {
          date = this.data.delivery_date;
          if(this.printType === 'order'){
            date = this.data.contract_date
          }
        }
        ar_date = date.split("-");
        return ar_date[1] + "/" + ar_date[2];
      }
    },
    /** 출력 */
    clickPrint() {
      this.$print(this.$refs.print);
    },
    /** 닫기 */
    closeDialog() {
      this.$emit("completed");
    },
    toggleAddrEditing() {
      this.addr_editing = !this.addr_editing;
      this.btn_addr_text = this.addr_editing ? "변경" : "확인";
    },
    toggleEmailEditing() {
      this.email_editing = !this.email_editing;
      this.btn_email_text = this.email_editing ? "확인" : "변경";
    },
    toggleBankAccountEditing() {
      this.bankAccount_editing = !this.bankAccount_editing;
      this.btn_bankAccount_text = this.bankAccount_editing ? "확인" : "변경";
    },
    isGlass(row, value) {
      if (row.product_kind === "GLASS" && row.size) {
        if(value.includes('/')) value = value.split('/')[0]
        const [horizontal, vertical] = value.split("*").map(x => Number(x));
        const return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : return_value < 3 ? 3 : return_value;
      }
      return "";
    }
  }
};
</script>

<style lang="scss">
.ContractMultiPrint {
  .title {
    height: 60px;
    line-height: 60px;
    color: black;
    background-color: #eee;
    font-size: 35px;
    font-weight: bold;
    text-align: center;
  }
  .info {
    color: black;
    padding-top: 20px;
    font-size: 1.4em;
    hr {
      width: 100%;
    }
    span {
      display: block;
      width: 350px;
      min-height: 30px;
      margin: auto;
    }
  }
  .supplier-table {
    tr {
      height: 24px;
    }
  }
  .price {
    span:not(:last-child) {
      font-size: 20px;
      font-weight: bold;
      padding-right: 20px;
    }
  }
  .detail-table {
    margin-top: -3px;
    tr {
      height: 30px;
    }
  }
  .desc-row {
    border-top-style: double;
  }
  .cell-height {
    height: 30px;
  }
  .stamp {
    position: absolute;
    opacity: 0.7;
    margin-top: 10px;
    right: 10px;
  }
  .align-center {
    .el-textarea__inner {
      display: block;
      font-size: 1.2em;
      width: 350px;
      height: 60px;
      min-height: 30px;
      margin: auto;
      color: #606266;
      font-weight: bold;
    }
  }
}
</style>
<style lang="scss" media="print">
.ContractMultiPrint {
  @page {
    size: A4 portrait;
  }
  .ContractMultiPrint.landscape {
    page: landscape;
  }
  .landscape-font > td {
    font-size: 14px !important;
  }
}
</style>